// extracted by mini-css-extract-plugin
module.exports = {"allItemsLink":"_b31e0d9"};